var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Edit"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M23.253 2.91C23.3931 3.05058 23.4718 3.24099 23.4718 3.4395C23.4718 3.63801 23.3931 3.82842 23.253 3.969L21.6885 5.535L18.6885 2.535L20.253 0.969C20.3936 0.828397 20.5844 0.74941 20.7832 0.74941C20.9821 0.74941 21.1729 0.828397 21.3135 0.969L23.253 2.9085V2.91ZM20.628 6.594L17.628 3.594L7.4085 13.815C7.32594 13.8975 7.2638 13.9982 7.227 14.109L6.0195 17.73C5.9976 17.796 5.99449 17.8668 6.01052 17.9345C6.02655 18.0022 6.06108 18.0641 6.11026 18.1132C6.15944 18.1624 6.22133 18.197 6.28901 18.213C6.35669 18.229 6.42749 18.2259 6.4935 18.204L10.1145 16.9965C10.2251 16.9601 10.3258 16.8985 10.4085 16.8165L20.628 6.5955V6.594Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5 20.25C1.5 20.8467 1.73705 21.419 2.15901 21.841C2.58097 22.2629 3.15326 22.5 3.75 22.5H20.25C20.8467 22.5 21.419 22.2629 21.841 21.841C22.2629 21.419 22.5 20.8467 22.5 20.25V11.25C22.5 11.0511 22.421 10.8603 22.2803 10.7197C22.1397 10.579 21.9489 10.5 21.75 10.5C21.5511 10.5 21.3603 10.579 21.2197 10.7197C21.079 10.8603 21 11.0511 21 11.25V20.25C21 20.4489 20.921 20.6397 20.7803 20.7803C20.6397 20.921 20.4489 21 20.25 21H3.75C3.55109 21 3.36032 20.921 3.21967 20.7803C3.07902 20.6397 3 20.4489 3 20.25V3.75C3 3.55109 3.07902 3.36032 3.21967 3.21967C3.36032 3.07902 3.55109 3 3.75 3H13.5C13.6989 3 13.8897 2.92098 14.0303 2.78033C14.171 2.63968 14.25 2.44891 14.25 2.25C14.25 2.05109 14.171 1.86032 14.0303 1.71967C13.8897 1.57902 13.6989 1.5 13.5 1.5H3.75C3.15326 1.5 2.58097 1.73705 2.15901 2.15901C1.73705 2.58097 1.5 3.15326 1.5 3.75V20.25Z",
  fill: "currentColor"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/edit.65ee6b1ac83706ae12b48ef0b877d8c7.svg";